<div class="bg-container">
  <div class="container maintence">
    <div class="maintence-container">
      <div class="text-center maintence-logo mb-3">
        <img src="./assets/logo.png" />
      </div>

      <p><b>{{ maintenanceHeader }}</b></p>
      <p style="white-space: pre-line">{{ maintenanceText }}</p>
      <div class="text-center">
        <button class="btn btn-primary" (click)="refreshApp()" >Refresh</button>
      </div>
    </div>
  </div>

</div>
